import { render, staticRenderFns } from "./ViewPaymentTrxn.vue?vue&type=template&id=09364c43&"
import script from "./ViewPaymentTrxn.vue?vue&type=script&lang=js&"
export * from "./ViewPaymentTrxn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports